import { create } from "../../../common/utils/zustand_state_manager";
import { IFinanceiroRepository } from "../../../features/financeiro/domain/repositories/financeiro_repositories";
import { useFinanceiroServices } from "./use_services";
import { FinanceiroRepository } from "../../../features/financeiro/data/repositories/financeiro_repositories";

/**
 * useFinanceiroRepositories
 */

type State = {
  financeiroRepository: IFinanceiroRepository,
};

export const useFinanceiroRepositories = create<State>((set, get) => {
  const { financeiroService } = useFinanceiroServices.getState();
  return ({
    financeiroRepository: new FinanceiroRepository(financeiroService),
  });

});